import { useEffect, useState } from "react";
import LoaderWrapper from "../../../widgets/loaderWrapper/LoaderWrapper";
import MapWidget from "../../../widgets/map/mapWidget/MapWidget";
import { useParams } from "react-router-dom";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import { getAllRoadObjectsLayer, getWKTFeatureVectorLayer } from "../../../widgets/map/mapFeatures/layers";
import { countExtentFromWKTFeatures } from "../../../widgets/map/mapFeatures/helpers";
import { fetchObjectGeometry } from "../../../api/mapApi";
import ContentHeader from "../../../widgets/contentHeader/ContentHeader";
import ToastMessageContainer from "../../../widgets/toastMessageContainer/ToastMessageContainer";
import { useDispatch } from "react-redux";
import { showToastMessage } from "../../../stateManagement/reducers";

export function MapObject() {
    // определение необходимых параметров из URL
    const { objectId, objectTypeName } = useParams();
    const dispatch = useDispatch()
    const objectTypes = getItemWebStorage('objectTypes')
    const [mapTitle, setMapTitle] = useState<string>('')
    const [additionalLayers, setAdditionalLayers] = useState<any>([]);
    const [fitExtent, setFitExtent] = useState<any>();
    const [fitExtentPadding, setFitExtentPadding] = useState<any>([]);
    const [isError, setIsError] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const roadsLayer = getAllRoadObjectsLayer()
    const permanentLayers: any = [roadsLayer]

    async function getObject() {
        if (objectTypeName && objectId) {
            setIsLoading(true)
            const captionSingular = objectTypes.find((objectType: any) => objectType?.name === objectTypeName)?.captionSingular
            setMapTitle(captionSingular)
            const addressTypes = getItemWebStorage('addressTypes')
            const urlType = addressTypes.value.find((type: any) => type.name === objectTypeName) != null ? 'address' : 'objects'
            const { data: objectWKTGeometry, isError, isSuccess } = await fetchObjectGeometry(urlType, objectTypeName, objectId)
            setIsError(isError)
            setIsLoading(false)
            if (isSuccess) {
                const objectLayer = getWKTFeatureVectorLayer(objectWKTGeometry)
                setAdditionalLayers([objectLayer])
                const extent = countExtentFromWKTFeatures(objectWKTGeometry)
                setFitExtent(extent)
                setFitExtentPadding([350, 350, 350, 350])
            }
        }
    }

    useEffect(() => {
        getObject()
    }, [])

    useEffect(() => {
        if (isError) {
            dispatch(showToastMessage({ messageText: "Не удалось загрузить объект на карте", messageType: "error" }))
        }
    }, [isError])

    return (
        <>
            <ContentHeader title={mapTitle} objectTypeName={objectTypeName} type="map" option="object" />
            <div className="map-widget-with-toast">
                <ToastMessageContainer />
                <LoaderWrapper isLoading={isLoading}>
                    <MapWidget additionalLayers={additionalLayers} permanentLayers={permanentLayers} propsFitExtent={fitExtent} propsFitExtentPadding={fitExtentPadding} />
                </LoaderWrapper>
            </div>
        </>
    )
}
